<template>
    <div class="form">
        <fieldset class="fieldset mrg" data-mrgt="20" :disabled="isLoading">
            <div class="form-items cf">
                <div class="item">
                    <div class="control">
                        <label class="label" for="Email">{{ localizer.get("App.Account.Email") }}</label>
                        <input type="email" id="Email" v-model.lazy="formData.email" autocomplete="email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'textbox']" />
                        <span class="valid-sign">*</span>
                    </div>
                </div>
                <div class="item">
                    <div class="control" data-type="password">
                        <label class="label" for="Password">{{ localizer.get("App.Account.Password") }}</label>
                        <input type="password" id="Password" v-model.lazy="formData.Password" autocomplete="off" :class="[{ 'input-validation-error': isValidationError('Password') }, 'textbox']" />
                        <button class="show-password" @click="formHelper.showPassword('Password'), showPasswordIcon()">
                            <span v-if="isHidden" class="icon fastic-eye-show"></span>
                            <span v-else class="icon fastic-eye-hide"></span>
                        </button>
                        <span class="valid-sign">*</span>
                    </div>
                </div>
                <div v-if="options?.isPasswordCheck" class="item">
                    <div class="control" data-type="password">
                        <label class="label" for="ConfirmPassword">{{ localizer.get("Account.Common.PasswordCheck") }}</label>
                        <input type="password" id="ConfirmPassword" v-model.lazy="formData.passwordCheck" autocomplete="off" :class="[{ 'input-validation-error': isValidationError('ConfirmPassword') }, 'textbox']" />
                        <button class="show-password" @click="formHelper.showPassword('ConfirmPassword'), showPasswordIconCheck()">
                            <span v-if="isHiddenCheck" class="icon fastic-eye-show"></span>
                            <span v-else class="icon fastic-eye-hide"></span>
                        </button>
                        <span class="valid-sign">*</span>
                    </div>
                </div>
            </div>
        </fieldset>
        <fieldset class="fieldset">
            <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                <ul>
                    <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                </ul>
            </div>
            <div class="form-items" data-type="buttons">
                <div class="item calltoaction">
                    <button id="ButtonSubmit" class="button" @click="submitForm()" :disabled="isLoading"><span class="lable">{{ localizer.get("Account.Common.Button_Next") }}</span></button>
                </div>
            </div>
        </fieldset>
    </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
    code?: string
}>();

const formHelper = FormHelper;
const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);
const isHidden = ref(true);
const isHiddenCheck = ref(true);
const options = ref<any>(null);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
});

async function submitForm() {
    validationErrors.value = [];

    isLoading.value = true;
    formData.value.code = props.code;

    try {
        let response = await Axios.post(routes.Account_PasswordReset, formData.value);

        isSuccess.value = true;

        GTagHelper.sendEvent("form_submit", "account_login");

        window.location.href = response.data.redirectUrl ? response.data.redirectUrl : "/";
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}

function showPasswordIconCheck() {
    isHiddenCheck.value = !isHiddenCheck.value;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>
